import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./Wallet.module.css";
import NavSlider from "../NavSlider/NavSlider";
import SplashScreen from "../../SplashScreen";

/* =========================================================
   TRANSACTION DATA
========================================================= */

const transactionData = [
  {
    id: 1,
    name: "Ridhwan Nordin",
    date: "June 6, 2023 at 3:36 PM",
    amount: "+ ₹1,800",
    type: "credit",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80",
  },
  {
    id: 2,
    name: "Ridhwan Nordin",
    date: "June 6, 2023 at 3:36 PM",
    amount: "+ ₹1,800",
    type: "credit",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80",
  },
  {
    id: 3,
    name: "Ridhwan Nordin",
    date: "June 6, 2023 at 3:36 PM",
    amount: "+ ₹1,800",
    type: "credit",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80",
  },
  {
    id: 4,
    name: "Ridhwan Nordin",
    date: "June 6, 2023 at 3:36 PM",
    amount: "+ ₹1,800",
    type: "credit",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80",
  },
  {
    id: 5,
    name: "Ridhwan Nordin",
    date: "June 6, 2023 at 3:36 PM",
    amount: "+ ₹1,800",
    type: "credit",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80",
  },
  {
    id: 6,
    name: "Ridhwan Nordin",
    date: "June 6, 2023 at 3:36 PM",
    amount: "+ ₹1,800",
    type: "credit",
    avatar:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80",
  },
];

/* =========================================================
   WALLET COMPONENT
========================================================= */

export default function Wallet() {
  const navigate = useNavigate();
  const { userIds, deviceUuid } = useParams();

  const basePath = `/${userIds}/${deviceUuid}`;

  /* =======================================================
     STATE
  ======================================================= */

  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("wallet");
  const [menuOpen, setMenuOpen] = useState(false);

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const API_URL = "https://coinyoco.world/brobizee-api/get_user.php";
  const userIdA = localStorage.getItem("user_id");

  /* =======================================================
     FETCH USER
  ======================================================= */

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        setError("");

        if (!userIdA) {
          setError("User ID not found in localStorage");
          setLoading(false);
          return;
        }

        console.log("Fetching user:", userIdA);

        const response = await fetch(
          `${API_URL}?user_id=${encodeURIComponent(userIdA)}`
        );

        const responseText = await response.text();

        console.log("RAW GET USER RESPONSE:", responseText);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${responseText}`);
        }

        let data;
        try {
          data = JSON.parse(responseText);
        } catch (jsonError) {
          console.error("Invalid JSON:", responseText);
          throw new Error("PHP API returned invalid JSON");
        }

        console.log("GET USER RESULT:", data);

        if (data.success) {
          setUser(data.user);
        } else {
          setError(data.message || "Unable to fetch user data");
        }
      } catch (error) {
        console.error("Fetch user error:", error);
        setError(
          error.message || "Something went wrong while loading user data"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userIdA]);

  /* =======================================================
     FILTER TRANSACTIONS
  ======================================================= */

  const filteredTransactions = transactionData.filter((tx) =>
    tx.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  /* =======================================================
     NAVIGATION
  ======================================================= */

  const goTo = (tab, page) => {
    setActiveTab(tab);
    navigate(`${basePath}/${page}`);
  };

  const handleMenu = () => {
    setMenuOpen(true);
  };

  /* =======================================================
     LOADING
  ======================================================= */

  if (loading) {
    return (
      <div className="show-data-page">
        <div className="show-data-card">
          <SplashScreen />
        </div>
      </div>
    );
  }

  /* =======================================================
     ERROR
  ======================================================= */

  if (error) {
    return (
      <div className="show-data-page">
        <div className="show-data-card">
          <h2>Error</h2>
          <p>{error}</p>
          <button type="button" onClick={() => window.location.reload()}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  /* =======================================================
     NO USER
  ======================================================= */

  if (!user) {
    return (
      <div className="show-data-page">
        <div className="show-data-card">
          <h2>No user data found</h2>
        </div>
      </div>
    );
  }

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div className={styles["ios-screen-wrapper"]}>
      {/* =====================================================
          NAV SLIDER — ✅ NOW PASSING USER PROP
      ====================================================== */}

      <NavSlider
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        navigate={navigate}
        user={user}              // ✅ FIX: pass user data
        basePath={basePath}      // ✅ FIX: pass basePath for navigation
      />

      {/* =====================================================
          DEVICE FRAME
      ====================================================== */}

      <div className={styles["ios-device-frame"]}>
        <div className={styles["ios-scroll-container"]}>
          {/* =================================================
              HEADER
          ================================================= */}

          <header className={styles["wallet-header"]}>
            <div className={styles["header-top-bar"]}>
              <h1 className={styles["header-title"]}>Wallet</h1>

              <button
                type="button"
                className={styles["menu-hamburger-btn"]}
                aria-label="Open Menu"
                onClick={handleMenu}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#0066cc"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                >
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              </button>
            </div>

            {/* =================================================
                USER PROFILE
            ================================================= */}

            <div className={styles["user-profile-row"]}>
              <div className={styles["avatar-ring"]}>
                <img
                  src={user.profile_url}
                  alt={user.name || "Profile"}
                  className={styles["user-avatar"]}
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              </div>

              <div className={styles["user-info"]}>
                <span className={styles["user-phone"]}>
                  {user.mobile_number || "-"}
                </span>

                <span className={styles["user-upi"]}>
                  prathamesh52222@okaxis
                </span>
              </div>
            </div>
          </header>

          {/* =================================================
              BANK ACCOUNT
          ================================================= */}

          <section className={styles["bank-card-container"]}>
            <div className={styles["bank-card"]}>
              <div className={styles["bank-icon-box"]}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M3 21h18" />
                  <path d="M3 10h18" />
                  <path d="M5 10v11" />
                  <path d="M9 10v11" />
                  <path d="M15 10v11" />
                  <path d="M19 10v11" />
                  <path d="M12 3L2 10h20L12 3z" />
                </svg>
              </div>

              <div className={styles["bank-details"]}>
                <span className={styles["bank-name"]}>ICICI Bank</span>
                <span className={styles["bank-account-dots"]}>
                  • • • • 4411
                </span>
              </div>
            </div>

            <button type="button" className={styles["change-account-btn"]}>
              <span>CHANGE MY BANK ACCOUNT</span>
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </section>

          {/* =================================================
              BALANCE
          ================================================= */}

          <div className={styles["balance-banner"]}>
            <div className={styles["balance-info"]}>
              <span className={styles["balance-label"]}>
                YOUR WALLET
                <br />
                BALANCE
              </span>

              <div className={styles["balance-amount-row"]}>
                <span className={styles["amount-val"]}>₹ 0</span>
              </div>
            </div>

            <div className={styles["balance-actions"]}>
              <div className={styles["wallet-icon-badge"]}>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.99 1-1.72V9c0-.73-.41-1.37-1-1.72zM20 9v6h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3zM5 5h14v2H5V5z" />
                </svg>
              </div>

              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>
          </div>

          {/* =================================================
              ACTION BUTTONS
          ================================================= */}

          <div className={styles["action-grid"]}>
            <button
              type="button"
              className={`${styles["ios-action-btn"]} ${styles["add-btn"]}`}
            >
              <span>Add money</span>
            </button>

            <button
              type="button"
              className={`${styles["ios-action-btn"]} ${styles["invest-btn"]}`}
            >
              <span>INVEST</span>
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a10 10 0 0 1 10 10h-10V2z" />
              </svg>
            </button>
          </div>
        </div>

        {/* =================================================
            BOTTOM NAVIGATION
        ================================================= */}

        <div className={styles["bottom-nav-wrapper"]}>
          <nav className={styles["bottom-nav"]} aria-label="Bottom Navigation">
            <button
              type="button"
              className={`${styles["nav-btn"]} ${
                activeTab === "home" ? styles.active : ""
              }`}
              onClick={() => goTo("home", "userprofile")}
              aria-label="Home"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
              <span className={styles["nav-label"]}>Home</span>
            </button>

            <button
              type="button"
              className={`${styles["nav-btn"]} ${
                activeTab === "search" ? styles.active : ""
              }`}
              onClick={() => goTo("search", "search")}
              aria-label="Search"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <span className={styles["nav-label"]}>Search</span>
            </button>

            <button
              type="button"
              className={`${styles["nav-btn"]} ${
                activeTab === "clipboard" ? styles.active : ""
              }`}
              onClick={() => goTo("clipboard", "tasks")}
              aria-label="Tasks"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                <rect x="8" y="2" width="8" height="4" rx="1" />
                <path d="M8 11h8" />
                <path d="M8 15h5" />
              </svg>
              <span className={styles["nav-label"]}>Tasks</span>
            </button>

            <button
              type="button"
              className={`${styles["nav-btn"]} ${
                activeTab === "media" ? styles.active : ""
              }`}
              onClick={() => goTo("media", "media")}
              aria-label="Media"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
              <span className={styles["nav-label"]}>Media</span>
            </button>

            <button
              type="button"
              className={`${styles["nav-btn"]} ${
                activeTab === "wallet" ? styles.active : ""
              }`}
              onClick={() => goTo("wallet", "wallet")}
              aria-label="Wallet"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="6" width="20" height="12" rx="3" />
                <path d="M18 12h.01" />
              </svg>
              <span className={styles["nav-label"]}>Wallet</span>
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}